<template>
    <div class="header">
        <i class="material-icons exit">exit_to_app</i>
        <span class="title">{{headerTitle}}</span>
        <i class="material-icons menu-toggler" @click="toggleSideMenuHandler">menu</i>
        <!-- <div class="support-btn">
            <span class="text">Support</span>
            <i class="support material-icons">contact_support</i>
        </div>-->
        <div class="left-content">
            <div v-if="showRequestPartnersButton" class="btn request" @click="openSendMessagePopup"><span style="margin-right: 0.4rem" class="material-icons">mail</span><span>{{$t('SEND__REQUEST_PARTNERS')}}</span></div>
            <div class="balance-container">
                <span>Credit :</span>
                <span class="amount">{{ creditAmount }}</span>
            </div>
            <div class="header-menu" @click="menuVisible = !menuVisible">
                <div class="initial-box">
                    <span class="initials">{{ adminInitials }}</span>
                </div>
                <span class="name">{{ adminName }}</span>
                <div class="material-icons">keyboard_arrow_down</div>
                <ul class="menu-items-container" v-show="menuVisible">
                    <li @click="logoutHandler">Log Out</li>
                </ul>
            </div>
            <ul class="language-change" @click="languageOptionsVisible = !languageOptionsVisible">
                <li class="selected">
                    <country-flag :country="languageInitials(selectedLanguage)" size="small" />
                    <span>{{ selectedLanguage.toUpperCase() }}</span>
                </li>
                <div class="options" v-show="languageOptionsVisible">
                    <li
                        v-for="lang in languages"
                        :key="lang"
                        v-show="selectedLanguage != lang"
                        @click="changeLanguage(lang)"
                    >
                        <country-flag :country="languageInitials(lang)" size="small" />
                        <span>{{lang.toUpperCase()}}</span>
                    </li>
                </div>
            </ul>
        </div>
    </div>
</template>

<script>
import EventBus from '@/Helpers/EventBus.js'
import axios from '@/Helpers/AxiosInstance.js'
import CountryFlag from 'vue-country-flag'
export default {
    components: {
        CountryFlag,
    },
    created() {
        //required because when page is refreshed,
        //we need to get the path name
        this.headerTitle = this.$route.name

        EventBus.$on('updateBalance', this.updateBalance)

        // Update balance periodically
        setInterval(this.updateBalance.bind(this), 10 * 1000)

        // set language
        var defaultLanguage = 'en'
        if(this.is90Tip) defaultLanguage = 'de'
        this.selectedLanguage = localStorage.getItem('language') || defaultLanguage
    },
    props: {
        logout: Function,
        toggle: Function,
        showRequestPartnersButton: Boolean
    },
    data: function() {
        return {
            headerTitle: '',
            menuVisible: false,
            menuToggledOnMobile: false,
            selectedLanguage: 'en',
            languageOptionsVisible: false,
        }
    },
    watch: {
        $route(to) {
            this.headerTitle = to.name
        },
    },
    methods: {
        updateBalance() {
            axios.get('WebShop/GetUserShopAndWebShops').then(resp => {
                this.$store.state.webshops = resp.data.webShops
            })
        },

        logoutHandler() {
            this.logout()
        },
        toggleSideMenuHandler() {
            this.toggle()
        },
        languageInitials(initials) {
            if(initials == 'en') return 'gb'
            return initials
        },
        changeLanguage(lang) {
            localStorage.setItem('language', lang)
            this.$i18n.locale = lang
            this.selectedLanguage = lang
            if(Object.keys(this.$i18n.messages[lang]).length != 0) return
            axios.get('WebShop/GetTranslations', {params: {'language': lang}}).then(resp => {
                let translations = resp.data.translations
                let message = {}
                translations.forEach(tr => {
                    let groupName = resp.data.translationGroups.filter(el => el.id == tr.groupId)[0].name
                    let keyName = resp.data.translationKeys.filter(el => el.id == tr.keyId)[0].name
                    message[groupName+'__'+keyName] = tr['text']
                })
                this.$i18n.setLocaleMessage(lang, message)
                this.$i18n.locale = lang
            })
        },
        getCommaSeparatedAmount(amount) {
            let amountStr = ''
            for(let i = amount.length-1, j = 1; i >= 0; i--) {
                amountStr = amount[i] + amountStr
                if(j % 3 == 0 && i != 0) amountStr = ',' + amountStr
                j++
            }
            return amountStr
        },
        openSendMessagePopup() {
            this.$emit('contactPopupVisible', true)
        }
    },
    computed: {
        isSupervisor() {
            return this.$store.state.shop
        },
        creditAmount() {
            if(this.isSupervisor) {
                var shop = this.$store.state.shop
                var amount = shop.availableCreditDecimal.toString()
                var amountStr = ''
                if(amount.includes('.')) {
                    amountStr = this.getCommaSeparatedAmount(amount.split('.')[0]) + '.' +amount.split('.')[1]
                }
                else {
                    amountStr = this.getCommaSeparatedAmount(amount)
                }
                var code = shop.currencyCode
                return amountStr + ' ' + code
            }
            else {
                var webshop = this.$store.state.webshops[0]
                return webshop.availableCreditDecimal + ' ' + webshop.currencyName
            }
        },
        adminName() {
            if(this.isSupervisor) return this.$store.state.shop.name
            return this.$store.state.webshops[0].calculatedName
        },
        adminInitials() {
            return this.adminName.substring(0,2)
        },
        is90Tip() {
            return ~window.location.href.indexOf('90tip')
        },
        languages() {
            if(this.is90Tip) return ['de', 'en', 'nl', 'tr', 'ru']
            return ['en', 'de', 'nl', 'tr', 'ru', 'fr', 'it']
        },
    },
}
</script>

<style scoped lang="scss">
.header {
    width: calc(100% - 250 *#{$rem});
    margin-left: 250 * $rem;
    height: 61 * $rem;
    display: flex;
    position: fixed;
    top: 0;
    z-index: 10;
    background-color: $background;
    border-bottom: $rem solid #cbced8;
    align-items: center;

    .exit {
        color: #84868c;
        font-size: 24 * $rem;
        margin-left: 16 * $rem;
        margin-right: 15 * $rem;
        transform: rotateZ(180deg);
    }

    span.title {
        font-size: 14 * $rem;
        color: rgba(65, 65, 65, 0.705);
        font-weight: 700;
    }

    .support-btn {
        background-color: $green-main;
        height: 34 * $rem;
        width: 118 * $rem;
        border-radius: 17 * $rem;
        display: flex;
        align-items: center;
        margin-left: auto;
        color: white;
        position: relative;
        margin-right: 58 * $rem;
        cursor: pointer;

        &:hover {
            filter: brightness(1.1);
        }

        span.text {
            font-size: 14 * $rem;
            font-weight: 400;
            margin-left: 18 * $rem;
            margin-right: 15 * $rem;
        }

        i.support {
            font-size: 24 * $rem;
        }

        &:after {
            position: absolute;
            top: 0;
            bottom: 0;
            margin: auto;
            right: -29 * $rem;
            content: '';
            background-color: #d4e2e9;
            width: 1 * $rem;
            height: 30 * $rem;
        }
    }

    .left-content {
        margin-left: auto;
        display: flex;
        align-items: center;

        .btn {
            display: flex;
            align-content: center;
            justify-content: center;
            width: 11.6667rem;
            margin-right: 1rem;

            &.request {
                min-width: unset !important;

                @media (max-width: 768px) {
                    width: 2.4rem;

                    .material-icons {
                        margin: 0 !important;
                        font-size: 1.6rem;
                    }

                    span:not(.material-icons) {
                        display: none;
                    }
                }
            }
        }
    }

    .balance-container {
        margin-right: 1.3rem;
        position: relative;
        color: #5f5f5fda;

        .amount {
            margin-left: 8 * $rem;
            font-weight: 500;
            color: #5f5f5f;
        }

        &:after {
            position: absolute;
            top: 0;
            bottom: 0;
            margin: auto;
            right: -29 * $rem;
            content: '';
            background-color: #d4e2e9;
            width: 1 * $rem;
            height: 30 * $rem;
        }
    }

    .header-menu {
        margin-right: 0.0375rem;
        display: flex;
        align-items: center;
        position: relative;
        cursor: pointer;

        .initial-box {
            width: 29 * $rem;
            height: 29 * $rem;
            border-radius: 2 * $rem;
            background-color: #d4e2e9;
            display: flex;
            align-items: center;
            justify-content: center;
            color: #40aee1;

            .initials {
                font-size: 14 * $rem;
                font-weight: 700;
            }
        }

        .name {
            color: #5f5f5f;
            margin-left: 10 * $rem;
            margin-right: 9 * $rem;
            font-size: 14 * $rem;
            font-weight: 700;
        }

        i {
            font-size: 24 * $rem;
        }

        .menu-items-container {
            position: absolute;
            list-style: none;
            background-color: white;
            top: 44 * $rem;
            left: -30 * $rem;
            width: 150%;
            border: 1 * $rem solid #d4e2e9;
            border-top: none;
            // border-right: none;
            padding-top: 10 * $rem;
            background-color: $background;

            li {
                height: 30 * $rem;
                padding-left: 30 * $rem;
                line-height: 30 * $rem;
                border-bottom: 1 * $rem solid rgb(241, 241, 241);
                color: #707070;
                font-weight: 400;
                font-size: 14 * $rem;
                background-color: #ffffff;

                &:hover {
                    cursor: pointer;
                    background-color: $background;
                }
            }

            a {
                text-decoration: none;
            }
        }

        .language-change {
        }
    }

    ul.language-change {
        list-style: none;
        margin-left: 3rem;
        margin-right: 30 * $rem;
        position: relative;
        overflow: visible;
        color: #5f5f5f;
        cursor: pointer;

        &::after {
            position: absolute;
            top: 0;
            bottom: 0;
            margin: auto;
            left: -2.5rem;
            content: '';
            background-color: #d4e2e9;
            width: 0.0625rem;
            height: 1.875rem;
        }

        .options {
            position: absolute;
            top: 39 * $rem;
            left: -30 * $rem;
            border: 0.0625rem solid #d4e2e9;
            border-top: none;
            padding-top: 0.625rem;
            background-color: #f7f8fc;
            width: 100 * $rem;
            z-index: 4;

            li {
                background-color: #fff;
                padding: 10 * $rem;

                &:hover {
                    background-color: #f7f8fc;
                }
            }
        }

        li {
            display: flex;
            justify-content: center;
            align-items: center;
        }

        span.flag {
            margin-right: -15 * $rem;
            transform: scale(0.35);
        }
    }

    .menu-toggler {
        display: none;
    }
}

@media only screen and (max-width: 1024*$rem) {
    .header {
        margin-left: 0;
        width: 100%;

        .exit,
        .title {
            display: none;
        }

        .menu-toggler {
            display: block;
            padding: 0;
            font-size: 35 * $rem;
            margin-left: 0.7875rem;
            &:hover {
                cursor: pointer;
            }
        }
    }
}

@media only screen and (max-width: 800*$rem) {
    .balance-container {
        margin-right: 1.5rem !important; 
    }

    ul.language-change {
        margin-left: 1rem !important;
        margin-right: 1rem !important;

        &::after {
            display: none;
        }
    }
}
</style>
